import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import RichTextDisplay from '../../RichTextDisplay';

class VerbRadioInput extends Component {
    static propTypes = {
        value: PropTypes.any,
        onChange: PropTypes.func,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.string
            })
        ),
        answerSubmitted: PropTypes.bool,
        displayAnswerFeedback: PropTypes.bool,
        staticLabel: PropTypes.string,
        correctAnswerFeedback: PropTypes.string,
        incorrectAnswerFeedback: PropTypes.string,
        displayRichText: PropTypes.bool,
        currentUser: PropTypes.object,
        sendWorkspaceSegementEvent: PropTypes.func,
        nextSectionName: PropTypes.string,
    };

    handleOptionSelect = (value) => {
        const { onChange, answerSubmitted } = this.props;
        if (onChange && !answerSubmitted) {
            onChange(value);
        }
    };

    renderSelectionFeedback = (option = {}) => {
        const { value, correctAnswerFeedback, incorrectAnswerFeedback } = this.props;

        let feedbackSection = '';
        let feedbackClassName = '';
        let feedbackIconClassName;
        const optionSelected = option.id === value;

        if (optionSelected && option.isCorrect) {
            feedbackSection = correctAnswerFeedback;
            feedbackClassName = 'correct-answer';
            feedbackIconClassName = 'fas fa-check';
        }

        if (optionSelected && !option.isCorrect) {
            feedbackSection = incorrectAnswerFeedback;
            feedbackClassName = 'incorrect-answer';
            feedbackIconClassName = 'fa fa-times';
        }

        if (!optionSelected && option.isCorrect) {
            feedbackSection = 'This is the correct answer.';
            feedbackClassName = 'correct-answer';
        }

        return (
            <span className={cns(feedbackClassName, 'ms-auto')}>
                <i className={feedbackIconClassName} />
                {feedbackSection}
            </span>
        );
    };

    render() {
        const {
            options = [],
            value,
            staticLabel = '',
            answerSubmitted = false,
            displayAnswerFeedback = false,
            displayRichText,
            currentUser,
            nextSectionName,
            sendWorkspaceSegementEvent
        } = this.props;
        const answerSelected = answerSubmitted && displayAnswerFeedback;
        let displayOptions = null;
        let label;

        if (options) {
            displayOptions = options.map((option) => {
                const onClick = () => this.handleOptionSelect(option.value);
                const isSelected = value === option.value;
                label = staticLabel || option.label;

                return (
                    <div
                        key={option.value}
                        className={cns('verbRadioOption', { 'verbRadioOption-selected': isSelected })}
                        onClick={onClick}
                        onKeyPress={onClick}
                    >
                        <div className={cns('verbRadioOption-radio', { locked: answerSubmitted })} tabIndex={'0'} />
                        <div style={{ justifyContent: 'space-between' }}>
                            {displayRichText ? (
                                <RichTextDisplay
                                    className={'verbRadioOption-label'}
                                    htmlToDisplay={label}
                                    currentUser={currentUser}
                                    nextSectionName={nextSectionName}
                                    sendSegementEvent={sendWorkspaceSegementEvent}
                                />
                            ) : (
                                <span className={'verbRadioOption-label'}>{label}</span>
                            )}
                            {answerSelected ? this.renderSelectionFeedback(option) : null}
                        </div>
                    </div>
                );
            });
        }

        return <div className={'verbRadioWrapper'}>{displayOptions}</div>;
    }
}

export default VerbRadioInput;
